<template>
  <div class="mv_bussiness">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'电影台'},{name:'电影台业务'}]"></breadcrumb>
    <div class="mv_bussiness-wrap">
      <div class="mv_bussiness-contain">
        <mv-top-nav>
          <el-button @click="addOrganization()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新增单位</span>
          </el-button>
        </mv-top-nav>
        <div class="mv_bussiness-search_wrap">
          <div class="mv_bussiness-search_top">
            <div class="mv_bussiness-search_left">
              <el-select clearable
                         @change="searchChange()"
                         placeholder="全部平台"
                         v-model="params.platform">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
              <el-select clearable
                         @change="searchChange()"
                         placeholder="全部省份"
                         v-model="params.provid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
              <el-select clearable
                         style="width:135px"
                         @change="searchChange()"
                         placeholder="全部合同类型"
                         v-model="params.contractType">
                <el-option v-for="item in accrediTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
              <el-select clearable
                         @change="searchTypeChange()"
                         placeholder="全部类别"
                         v-model="params.moviceType">
                <el-option v-for="(item,index) in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
               <el-select clearable @change="searchChange()" placeholder="全部级别"  v-model="params.mCategory">
                <el-option
                  v-for="item in searchLevelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select @change="searchChange()"
              clearable
                         style="width:135px"
                         placeholder="合同状态不限"
                         v-model="params.contractStatus">
                <el-option label="停机"
                           :value="0"></el-option>
                <el-option label="在看"
                           :value="1"></el-option>
                <el-option label="过期"
                           :value="2"></el-option>
              </el-select>
              <el-select clearable
                         @change="searchChange()"
                         style="width:135px"
                         placeholder="到款情况不限"
                         v-model="params.toParagraph">
                <el-option label="未到款"
                           :value="0"></el-option>
                <el-option label="全部到款"
                           :value="1"></el-option>
                            <el-option label="部分到款"
                           :value="2"></el-option>
              </el-select>
            </div>
            <div class="mv_bussiness-search_right">
              <a class="mv_bussiness-table_download"
                 @click="exportExcel()">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel</a>
              <el-input clearable
                        prefix-icon="el-icon-search"
                        v-model="params.companyName"
                        @keyup.enter.native="searchChange()"
                        placeholder="搜索单位"></el-input>
            </div>
          </div>
          <div class="mv_bussiness-more">
            <div class="mv_bussiness-more_search"
                 v-show="searchShow">
              <el-row>
                <span class="mv_bussiness-more_search_title">合同起日</span>
                <time-range @timeRangeChange="contractOriginTimeChange"></time-range>
                <span class="mv_bussiness-more_search_title">代理商</span>
                <el-select clearable
                           @change="searchChange()"
                           v-model="params.agent">
                  <el-option v-for="item in agentList"
                             :key="item.id"
                             :label="item.name"
                             clearable
                             :value="item.id"></el-option>
                </el-select>
              </el-row>
              <el-row>
                <span class="mv_bussiness-more_search_title">合同止日</span>
                <time-range @timeRangeChange="contractStopTimeChange"></time-range>
                <span
                      class="mv_bussiness-more_search_title">经手人</span>
                <el-input @keyup.enter.native="searchChange()"
                          v-model="params.transactor"
                           clearable
                          ></el-input>
              </el-row>
              <el-row>
                <span class="mv_bussiness-more_search_title">到款日期</span>
                <time-range @timeRangeChange="toSectionTimeChange"></time-range>
                <span
                      class="mv_bussiness-more_search_title">卡号</span>
                <el-input @keyup.enter.native="searchChange()"
                          v-model="params.cardNumber"
                          clearable
                          ></el-input>
              </el-row>
              <el-row>
                <span class="mv_bussiness-more_search_title">添加日期</span>
                <time-range @timeRangeChange="addTimeChange"></time-range>
              </el-row>
            </div>
            <div @click="searchShow=!searchShow"
                 class="mv_bussiness-more_button">高级筛选
              <font-awesome-icon v-if="!searchShow"
                                 style="color:#96A6B8;margin-left:10px"
                                 :icon="['fas', 'angle-double-down']" />
              <font-awesome-icon v-else
                                 style="color:#F0722B;margin-left:10px"
                                 :icon="['fas', 'angle-double-up']" />
            </div>
          </div>
        </div>
        <div class="mv_bussiness-table-wrap">
          <div class="mv_bussiness-table_title">符合条件客户
            <span>{{clientNum}}</span>个，协议金额
            <span>{{amountNum}}</span>万</div>
          <div class="mv_bussiness-table">
            <table>
              <tr>
                <th>序号</th>
                <th>单位</th>
                <th>省份</th>
                <th>卡号</th>
                <th>平台</th>
                <th>日期</th>
                <th>类型</th>
                <th>状态</th>
                <th>到款</th>
              </tr>
              <tr v-for="(item,index) in clientsList"
                  :key="item.clientId">
                <td>{{index+1}}</td>
                <td> <a @click="gotoDetail(item.clientId)">{{item.clientName}}</a></td>
                <td>{{item.areaName}}</td>
                <td>{{item.clientCardno}}</td>
                <td>{{item.platformName}}</td>
                <td>{{item.starttime.split('T')[0]}} - {{item.stoptime.split('T')[0]}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.contractStatusDesc}}</td>
                <td>{{item.receiveDesc}}</td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="params.page"
                         class="mv_bussiness-pagination"
                         background
                         layout="prev, pager, next"
                         :total="listSize"></el-pagination>
        </div>
      </div>
    </div>
    <!--编辑基本信息-->
    <el-dialog class="mv_bussiness-dialog"
               title="基本信息"
               :visible.sync="movieClientFormShow">
      <el-form label-position="top"
               class="mv_bussiness-form">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="单位">
              <el-input v-model="movieClientForm.munitName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="省份">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mprovid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="类别">
              <el-select clearable
                         placeholder="请选择"
                         @change="formTypeChange"
                         v-model="movieClientForm.classId">
                <el-option v-for="(item,index) in formTypeList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
             <el-col :span="5">
            <el-form-item label="级别">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mcategory">
                <el-option v-for="item in categoryList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="卡号">
              <el-input v-model="movieClientForm.mcardno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="movieClientForm.maddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="客户号">
              <el-input v-model="movieClientForm.mclientno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="终端数">
              <el-input v-model="movieClientForm.mroom"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机器号">
              <el-input v-model="movieClientForm.mmacno"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮编">
              <el-input v-model="movieClientForm.mpostcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="关机原因">
              <el-input v-model="movieClientForm.mcreason"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="旧卡号">
              <el-input v-model="movieClientForm.moldno"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="首次开机日期">
              <el-date-picker v-model="movieClientForm.modate"
                              type="date"
                              placeholder="选择日期"
                             value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关机日期">
              <el-date-picker v-model="movieClientForm.mcdate"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="mv_bussiness-title">
          开机授权信息
          </div>
        </el-row>
         <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="起始日期">
              <el-date-picker v-model="movieClientForm.mstartTime"
                              type="date"
                              placeholder="选择日期"
                             value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终止日期">
              <el-date-picker v-model="movieClientForm.mstopTime"
                              type="date"
                              placeholder="选择日期"
                             value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="平台">
             <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mplatform">
                <el-option v-for="item in platformList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-select clearable
                         placeholder="请选择"
                         v-model="movieClientForm.mtype">
                <el-option v-for="item in accrediTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签约终端">
              <el-input clearable
                        @input="cpSignedeviceChange"
                        placeholder="请输入" v-model="movieClientForm.msignedevice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同金额">
              <el-input v-model="movieClientForm.mcontractmoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="经手人">
              <el-input v-model="movieClientForm.mperson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="代理商">
              <el-select clearable v-model="movieClientForm.mdealerId">
                    <el-option v-for="item in agentList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-form-item label="备注">
             <el-input type="textarea"
                      :rows="5"
                      v-model="movieClientForm.mcontent"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
       <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitEditMovieClient()">提 交</el-button>
        <el-button @click="movieClientFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import mvTopNav from '@/components/mvTopNav'
import timeRange from '@/components/timeRange'
export default {
  components: {
    breadcrumb,
    mvTopNav,
    timeRange
  },
  data() {
    return {
      listSize: 0,
      typeList: [],
      searchLevelList:[],
      providList: [],
      platformList: [],
      accrediTypeList: [],
      agentList: [],
      searchShow: false,

      params: {
        pageSize: 10,
        page: 1,
        companyName: '',
        platform: '',
        moviceType:'',
        mCategory:'',
        contractType:'',
        toParagraph: '',
        contractStatus: '',
        agent: '',
        transactor: '',
        toSectionEndTime: '',
        toSectionStartTime: '',
        addEndTime: '',
        addStartTime: '',
        contractOriginEndTime: '',
        contractOriginStartTime: '',
        contractStopEndTime: '',
        contractStopStartTime: '',
        cardNumber:'',
      },

      clientsList: [],
      amountNum: '',
      clientNum: '',

      movieClientForm: {},
      movieClientFormShow: false,

      formTypeList:[],
      categoryList:[]
    }
  },
  created() {
    this.getList()
    this.getSelectList()
  },
  methods: {
    getList() {
      let params = _.cloneDeep(this.params)
      params.moviceType = this.params.moviceType!==''?this.typeList[this.params.moviceType].id:''
      axios
        .post(api.movieClientList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取电影台客户资料列表成功', res.data.result)
            this.clientsList = res.data.result.pageResult.records
            this.listSize = res.data.result.pageResult.total
            this.amountNum = res.data.result.amountNum
            this.clientNum = res.data.result.clientNum
          } else {
            console.log('获取电影台客户资料列表失败', res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //添加单位Form的下拉框
    getSelectList() {
      Promise.all([
        //获取平台
        axios.get(api.getPlatformTypeList).then(res => {
          if (res.data.code === 0) {
            console.log('获取平台成功', res.data.result)
            this.platformList = res.data.result
          } else {
            console.log('获取平台失败', res.data.msg)
          }
        }),
        //获取电影台类别
        axios.get(api.clientCategory).then(res => {
          if (res.data.code === 0) {
            console.log("获取类型--级别列表成功", res.data.result);
            this.typeList = res.data.result;
            this.formTypeList = res.data.result
          } else {
            console.log("获取类型--级别列表失败", res.data.msg);
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        }),
        //获取合同类型
        axios.get(api.getAccrediTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取合同类型成功', res.data.result)
            this.accrediTypeList = res.data.result
          } else {
            console.log('获取合同类型失败', res.data.msg)
          }
        }),
        //获取代理商
        axios.get(api.getagent).then(res => {
          if (res.data.code === 0) {
            console.log('获取代理商列表成功', res.data.result)
            this.agentList = res.data.result
          } else {
            console.log('获取代理商列表失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    changePage(v) {
      this.params.page = v
      this.getList()
    },
    //新增单位
    addOrganization() {
      this.movieClientForm = {
        munitName: '',
        mprovid: '',
        classId:'',
        mcategory: '',
        mcardno: '',
        maddress: '',
        mclientno: '',
        mroom: '',
        mmacno: '',
        mpostcode: '',
        mcreason: '',
        moldno: '',
        modate: '',
        mcdate: '',
        mstartTime: '',
        mstopTime: '',
        mplatform: '',
        mtype: '',
        msignedevice: 110,
        mcontractmoney: 18480,
        mperson: '',
        mdealerId: '',
        mcontent: '',
      }
      this.movieClientFormShow = true
    },
    //提交基本信息
    submitEditMovieClient(){
      let params = _.cloneDeep(this.movieClientForm)
      params.classId = this.formTypeList[this.movieClientForm.classId].id
      axios
        .post(api.addMovieClient, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '添加客户成功',
              type: 'success'
            })
            this.movieClientFormShow = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //搜索条件改变
    searchChange() {
      this.params.page = 1
      this.getList()
    },
    //搜索类别改变
    searchTypeChange(){
      this.params.mCategory=''
      if(this.params.moviceType===''){
        this.searchLevelList = []

      }
       else{
       let index = this.params.moviceType
      this.searchLevelList = this.typeList[index].children;
       }
      this.searchChange()

    },
    formTypeChange(){
      this.movieClientForm.mcategory=''
      if(this.movieClientForm.classId===''){
        this.categoryList = []
      } else {
       let index = this.movieClientForm.classId
      this.categoryList = this.typeList[index].children;
      }

    },
    contractOriginTimeChange(time) {
      this.params.contractOriginStartTime = time.startTime
      this.params.contractOriginEndTime = time.endTime
      this.getList()
    },
     //终端改变金额
    cpSignedeviceChange(v) {
      if (v >= 110) {
        this.movieClientForm.mcontractmoney = (v - 110) * 168 + 18480
      }
    },
    addTimeChange(time) {
      this.params.addStartTime = time.startTime
      this.params.addEndTime = time.endTime
      this.getList()
    },
    toSectionTimeChange(time) {
      this.params.toSectionStartTime = time.startTime
      this.params.toSectionEndTime = time.endTime
      this.getList()
    },
    contractStopTimeChange(time) {
      this.params.contractStopStartTime = time.startTime
      this.params.contractStopEndTime = time.endTime
      this.getList()
    },
    //查看详情
    gotoDetail(id) {
      this.$router.push({ path: `/mv_channel/detail/${id}` })
    },
    //导出excel
    exportExcel() {
      axios({
        // 用axios发送post请求
        method: 'post',
        url: api.movieClientListExport,
        data: this.params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '电影台列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
  }
}
</script>

<style lang="scss">
.mv_bussiness {
  min-width: 1380px;
  .mv_bussiness-wrap {
    padding: 77px 30px 0px 30px;
    .mv_bussiness-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .mv_bussiness-search_wrap {
        position: relative;
        .mv_bussiness-search_top {
          background: #f8f8f8;
          padding: 20px 27px;
          display: flex;
          .mv_bussiness-search_left {
            display: flex;
            flex: 1;
            .el-select {
              width: 120px;
              margin-right: 13px;
            }
          }
          .mv_bussiness-search_right {
            display: flex;
            .mv_bussiness-table_download {
              cursor: pointer;
                           text-decoration: none;
              width: 108px;
              height: 38px;
              border-radius: 4px;
              background: #fff;
              margin-right: 10px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 38px;
              text-align: center;
            }
            .el-input {
              width: 178px;
            }
          }
        }
        .mv_bussiness-more {
          position: absolute;
          width: 100%;
          .mv_bussiness-more_search {
            padding: 18px 29px 29px 29px;
            background: #f8f8f8;
            border-top: 1px solid rgba(230, 227, 227, 1);
            .el-row {
              height: 40px;
              display: flex;
              align-items: center;
              margin-bottom: 23px;
              &:last-child {
                margin-bottom: 0px;
              }
              .mv_bussiness-more_search_title {
                margin-right: 15px;
                display: inline-block;
                width:60px;
              }
              .el-range-editor {
                margin-right: 30px;
              }
              .el-input {
                max-width: 194px;
              }
            }
          }
          .mv_bussiness-more_button {
            height: 36px;
            line-height: 36px;
            color: #9b9b9b;
            border: 1px solid rgba(233, 233, 233, 1);
            border-right: 0px;
            border-left: 0px;
            text-align: center;
            background: #fff;
            cursor: pointer;
          }
        }
      }
      .mv_bussiness-table-wrap {
        padding: 68px 30px 30px 30px;
        .mv_bussiness-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .mv_bussiness-table {
          margin-top: 16px;
          min-height: 470px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .mv_bussiness-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .mv_bussiness-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }
    .mv_bussiness-form {
      .mv_bussiness-title{
         color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .mv_bussiness-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
